<template>
  <b-container fluid="lg" class="h-100">
    <b-row class="row h-100">
      <b-col class="my-auto">
        <b-row class="justify-content-center mb-5">
          <b-col cols="3">
            <b-img
              :src="require('../assets/images/logo.png')"
              fluid
              alt="Domeo - assemblées"
            ></b-img>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mt-2">
          <b-col cols="10" class="text-center">
            <h4>plateforme de gestion des votes en assemblées générales</h4>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mt-5">
          <b-col cols="10" sm="6" md="5" lg="4">
            <b-form>
              <b-row>
                <b-col>
                  <b-alert
                    class="d-flex align-items-center"
                    :show="authError || error || meetingGuestAccessDenied"
                    variant="danger"
                  >
                    <font-awesome-icon icon="times-circle" size="2x" />
                    <span v-if="authError" class="ml-2">
                      Les informations d'identification invalides.
                    </span>
                    <span v-if="meetingGuestAccessDenied"
                      >Vous n'êtes pas autorisé. Contactez l'agence.</span
                    >
                    <span v-else class="ml-2">Désolé, quelque chose s'est mal passé.</span>
                  </b-alert>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <label>Utilisateur</label>
                  <b-input v-model="loginData.username" type="text" />
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <label>Mot de passe</label>
                  <div class="password-input-wrapper">
                    <b-input v-model="loginData.password" :type="inputType" />
                    <font-awesome-icon
                      :icon="inputType == 'password' ? 'eye-slash' : 'eye'"
                      @click="
                        inputType == 'password' ? (inputType = 'text') : (inputType = 'password')
                      "
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row class="justify-content-end mb-4">
                <b-col cols="auto">
                  <router-link :to="{ name: 'forgot-password' }">Mot de passe oublié ?</router-link>
                </b-col>
              </b-row>
              <b-row class="justify-content-center">
                <b-col cols="auto">
                  <b-button
                    :disabled="isLoadingLogin || !loginData.username || !loginData.password"
                    class="button btn-blue"
                    type="submit"
                    @click.prevent="login"
                  >
                    <span class="mr-2">S'identifier</span>
                    <font-awesome-icon v-if="!isLoadingLogin" icon="sign-in-alt" />
                    <font-awesome-icon v-else icon="spinner" pulse />
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import BuildingORM from "@/store/orm-axios/models/Building";
import BuildingOwnerORM from "@/store/orm-axios/models/BuildingOwner";
import MeetingORM from "@/store/orm-axios/models/Meeting";
import ContactORM from "@/store/orm-axios/models/Contact";

import MeetingGuestORM from "@/store/orm-axios/models/MeetingGuest";

export default {
  data() {
    return {
      showModal: false,
      loginData: {
        username: "",
        password: "",
      },
      selectedBuilding: null,
      buildingOwnersOfUser: null,
      inputType: "password",
      isLoadingLogin: false,
      // for login DESKTOP
      authError: false,
      error: false,
      meetingGuestAccessDenied: false,
    };
  },
  created() {
    this.$store.dispatch("entities/deleteAll");
  },
  methods: {
    login() {
      this.$store.state.isLoginLoading = true;
      this.isLoadingLogin = true;
      this.authError = false;
      this.error = false;
      this.$store
        .dispatch("auth/login", this.loginData)
        .then(() => {
          let roles = localStorage.getItem("roles");

          if (roles.includes("ROLE_BUILDING_OWNER")) {
            this.initBuildingOwnerUser();
          } else if (roles.includes("ROLE_MEETING_GUEST")) {
            this.initMeetingGuestUser();
          } else if (roles.includes("ROLE_MEETING_CONTACT")) {
            this.initContactUser();
          }
        })
        .catch(err => {
          this.$store.state.isLoginLoading = false;
          this.isLoadingLogin = false;
          if (err.response) {
            if (err.response.status === 401) this.authError = true;
            return;
          }
          this.error = true;
        });
    },
    initBuildingOwnerUser() {
      BuildingOwnerORM.api()
        .GET_BY_USER_ID(parseInt(localStorage.getItem("userId")))
        .then(() => {
          var buildinOwner = BuildingOwnerORM.query()
            .where("user_id", parseInt(localStorage.getItem("userId")))
            .first();
          localStorage.setItem("building_owner_id", buildinOwner.id);
          localStorage.setItem("building_id", buildinOwner.building_id);

          // Get only the building for the user
          this.getBuildingById(buildinOwner.building_id).then(() => {
            this.$router.push({ name: "meetings" });
            this.$store.state.isLoginLoading = false;
          });
        });
    },
    async initMeetingGuestUser() {
      MeetingGuestORM.api()
        .GET_BY_USER_ID(parseInt(localStorage.getItem("userId")))
        .then(async () => {
          var meetingGuest = MeetingGuestORM.query()
            .where("user_id", parseInt(localStorage.getItem("userId")))
            .first();

          if (meetingGuest.access_status != 1) {
            this.$store.state.isLoginLoading = false;
            this.isLoadingLogin = false;
            this.meetingGuestAccessDenied = true;
            setTimeout(() => {
              this.meetingGuestAccessDenied = false;
            }, 5000);
            return;
          }
          localStorage.setItem("meeting_guest_id", meetingGuest.id);
          localStorage.setItem("meeting_id", meetingGuest.meeting_id);

          await this.GetMeetingById(meetingGuest.meeting_id);

          this.$router.push({
            params: {
              id: meetingGuest.meeting_id,
            },
            name: "meeting-start",
          });
          this.$store.state.isLoginLoading = false;
        });
    },
    initContactUser() {
      ContactORM.api()
        .GET_BY_USER_ID(parseInt(localStorage.getItem("userId")))
        .then(() => {
          var contact = ContactORM.query()
            .where("user_id", parseInt(localStorage.getItem("userId")))
            .first();
          localStorage.setItem("contact_id", contact.id);
          localStorage.setItem("building_id", contact.building_id);

          // Get only the building for the user
          this.getBuildingById(contact.building_id).then(() => {
            this.$router.push({ name: "meetings" });
            this.$store.state.isLoginLoading = false;
          });
        });
    },
    // ???: .....................
    async GetMeetingById(id) {
      await MeetingORM.api()
        .GET(id)
        .then(res => {
          // set building_id
          var meeting = MeetingORM.find(id);
          localStorage.setItem("building_id", meeting.building_id);
        })
        .catch(err => {
          console.error("MeetingORM.api().GET error: ", err);
        });
    },
    async getBuildingById(buildingId) {
      await BuildingORM.api()
        .GET(buildingId)
        .then(res => {
          return res;
        })
        .catch(err => {
          return err;
        });
    },
  },
};
</script>
